import { _TXN_KEY } from "./reducer";
import ApiEngine from "../../common/api-engine";
import Routes from "../../common/api_routes";
import { ApiKey } from "../../common/constant";
import { stringIsNullOrEmpty } from "common/util";

/// <summary>
/// Author: YJ
/// </summary>
export function setSignature(signature) {
    return async dispatch => {
        dispatch({
            type: _TXN_KEY.SIGNATURE,
            signature: signature
        });
    }
}

/// <summary>
/// Author: CK
/// </summary>
export function setSessionToken(sessionToken) {
    return async dispatch => {
        dispatch({
            type: _TXN_KEY.SESSION_TOKEN,
            sessionToken: sessionToken
        });
    }
}

/// <summary>
/// Author: YJ
/// </summary>
export function setTransactionDetail(transaction, sessionToken) {
    return async dispatch => {
        dispatch({
            type: _TXN_KEY.TRANSACTION_DETAIL,
            transaction: transaction,
            sessionToken: sessionToken
        });
    }
}

/// <summary>
/// Author : CK
/// </summary>
export function callback(
    message,
    transactionId = null
) {
    return async (dispatch) => {
        let callbackUrl = "";
        let callbackMsg = "";

        try {
            if (transactionId != null) {
                var responseJson = await ApiEngine.get(Routes._CALLBACK + "?id=" + transactionId);

                if (!responseJson[ApiKey._API_SUCCESS_KEY]) {
                    throw responseJson[ApiKey._API_MESSAGE_KEY];
                }
                else {
                    callbackUrl = responseJson[ApiKey._API_DATA_KEY];
                    callbackMsg = responseJson[ApiKey._API_MESSAGE_KEY];
                }
            }

            dispatch({
                type: _TXN_KEY.CALLBACK,
                callbackUrl: callbackUrl,
                callbackMsg: !stringIsNullOrEmpty(callbackMsg) ? callbackMsg : message
            });
        }
        catch (err) {
            dispatch({
                type: _TXN_KEY.CALLBACK,
                message: !stringIsNullOrEmpty(err) ? err : message 
            });
        }
    };
}

/// <summary>
/// Author : CK
/// </summary>
export function clearCallback() {
    return async dispatch => {
        dispatch({
            type: _TXN_KEY.CLEAR_CALLBACK
        });
    }
}